import React from "react";
import "../styles/Footer.css";
import { FaFacebookF, FaInstagram, FaTwitter } from "react-icons/fa";

const Footer = () => (
  <footer className="footer">
    <div className="footer-content">
      <div className="footer-logo">
        <h3>GÜÇH DOORS</h3>
      </div>

      <div className="footer-links">
        <a href="#privacy">Privacy Policy</a>
        <a href="#terms">Terms of Service</a>
        <a href="#contact">Contact Us</a>
      </div>

      <div className="footer-social">
        <a
          href="https://facebook.com"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaFacebookF className="social-icon" />
        </a>
        <a
          href="https://www.instagram.com/guchdoors?igsh=ZXNzdWVqZ2tlNWc1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <FaInstagram className="social-icon" />
        </a>
        <a href="https://twitter.com" target="_blank" rel="noopener noreferrer">
          <FaTwitter className="social-icon" />
        </a>
      </div>
    </div>
    <div className="footer-bottom">
      <span>© 2024 GÜÇH DOORS. All Rights Reserved. | Powered By </span>
      <a
        href="https://vrnd.tech"
        target="_blank"
        rel="noopener noreferrer"
        className="vrnd-btn"
      >
        VRND Business Solutions
      </a>
    </div>
  </footer>
);

export default Footer;
